import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import Loading from 'uI/Loading/Loading';
import ShowDegree from 'uI/ShowDegree/ShowDegree';

import { getUrlDiploma, verifiedData } from 'store/verified-actions';

import classes from './VerifiedDegree.module.css';

const VerifiedDegree = () => {
  const [openDegree, setOpenDegree] = useState(false);
  const [urlDegree, setUrlDegree] = useState('false');
  const [courseDegree, setCourseDegree] = useState('false');
  const [endDate, setEndDate] = useState('false');
  const { idCampus, idCourse, idUserProgress } = useParams();
  const [load, setLoad] = useState(false);
  const [userInfo, setUserInfo] = useState('');

  useEffect(() => {
    (async () => {
      setUserInfo(
        await verifiedData(idCampus, idCourse, idUserProgress)
      );
      setLoad(false);
    })();
  }, []);

  const closeDegreeHandler = () => {
    setOpenDegree(false);
    setUrlDegree('');
    setCourseDegree('');
    setEndDate('');
  };

  const showDegreeHandler = () => {
    (async () => {
      setOpenDegree(true);
      setCourseDegree(userInfo.course);
      setUrlDegree(await getUrlDiploma(userInfo.code));
      setEndDate(userInfo.diplomaEpochTime);
    })();
  };

  return (
    <Paper className={classes.verifiedContainer} elevation={1}>
      {!load ? (
        <>
          {userInfo && (
            <>
              <p className={classes.title}>
                Verificación de diploma Mayahii
              </p>
              <p className={classes.description}>
                Te presentamos la información que contiene este
                Diploma:
              </p>
              <p className={classes.item}>
                <span className={classes.itemTitle}>Nombre:</span>
                <span className={classes.itemDescription}>
                  {userInfo.username}
                </span>
              </p>
              <p className={classes.item}>
                <span className={classes.itemTitle}>Código:</span>
                <span className={classes.itemDescription}>
                  {userInfo.code}
                </span>
              </p>
              <p className={classes.item}>
                <span className={classes.itemTitle}>Diploma:</span>
                <span className={classes.itemDescription}>
                  {userInfo.course}
                </span>
              </p>
              <p className={classes.item}>
                <span className={classes.itemTitle}>Fecha:</span>
                <span className={classes.itemDescription}>
                  {userInfo.diplomaDate}
                </span>
              </p>
              <p className={classes.item}>
                <span className={classes.itemTitle}>Academia:</span>
                <span className={classes.itemDescription}>
                  {userInfo.nameAcademy}
                </span>
              </p>
              <div className={classes.btnContainer}>
                <Button
                  className={classes.degreeBtn}
                  onClick={showDegreeHandler}
                >
                  Ver diploma
                </Button>
              </div>
            </>
          )}
          {openDegree && (
            <ShowDegree
              open={openDegree}
              closeDegree={closeDegreeHandler}
              urlDegree={urlDegree}
              courseDegree={courseDegree}
              endDate={endDate}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
      <Button to="/" component={Link} className={classes.return}>
        Ir a Mayahii
      </Button>
    </Paper>
  );
};

export default VerifiedDegree;
